import { titleCookiePolicy } from "../../src/components/MockData/MockData"
import ClientLayout from "../../src/layouts/client/ClientLayout"
import MetaHeader from "../../src/components/MetaHeader"
import { textConfig } from "../../constants/textLang"

const cookiePolicy = () => {

    return (
        <ClientLayout style={{ backgroundColor: 'black' }}>
            <section className="cookie-policy">
                <div className="content-footer-wrapper">
                    <div className="header-title">
                        <h1>{titleCookiePolicy.en.head_title}</h1>
                    </div>
                    <div className="main-content-text">
                        <div className="text">
                            <p>{titleCookiePolicy.en.head_title}</p>
                        </div>
                        <div className="text">
                            <p>{titleCookiePolicy.en.detail_one}</p>
                        </div>
                        <div className="text-detail">
                            <p>{titleCookiePolicy.en.text_cookie_is}</p>
                        </div>
                        <div className="text-detail">
                            <p>{titleCookiePolicy.en.text_cookie_detail}</p>
                        </div>
                        <div className="text-detail">
                            <ul>
                                {titleCookiePolicy.en.text_cookie_list.map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>
                        </div>
                        <div className="text">
                            <p>{titleCookiePolicy.en.text_cookie_info}</p>
                        </div>
                        <div className="text-detail">
                            <p>{titleCookiePolicy.en.text_cookie_use_info}</p>
                        </div>
                        <div className="text">
                            <p>{titleCookiePolicy.en.text_cookie_use}</p>
                        </div>
                        <div className="text-detail">
                            <p>{titleCookiePolicy.en.text_cookie_setting}</p>
                        </div>
                        <div className="text">
                            <p>{titleCookiePolicy.en.text_cookie_setting_detail}</p>
                        </div>
                    </div>
                </div>
            </section>
        </ClientLayout>
    )
}

export const getStaticProps = async (ctx) => {
    const { locale } = ctx
    const meta = {
        title: textConfig[locale]?.title_cookie,
        keywords: textConfig[locale]?.text_keyword,
        description: 'Luxury29 Car Rental Cookie Policy Page',
        image: 'main-pic.jpeg'
    };

    return {
        props: { meta },
    };
};


export default MetaHeader(cookiePolicy);